import { QueryClient } from '@tanstack/react-query';
import { LIVE_GC_MS, LIVE_STALE_MS } from '../config/liveSync';

export function createAdminQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: LIVE_STALE_MS,
        gcTime: LIVE_GC_MS,
        refetchOnWindowFocus: true,
        refetchOnReconnect: true,
        refetchOnMount: true,
        retry: 2,
        retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30_000),
        networkMode: 'online',
      },
      mutations: {
        retry: 1,
      },
    },
  });
}
